// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yWH87","type":"styles_type__3yzwL","choices":"styles_choices__3VcQf"};